import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignIn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 3.25C3 2.2835 3.7835 1.5 4.75 1.5H10.25C10.6642 1.5 11 1.83579 11 2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.61193 3 4.5 3.11193 4.5 3.25V20.75C4.5 20.8881 4.61193 21 4.75 21H10.25C10.6642 21 11 21.3358 11 21.75C11 22.1642 10.6642 22.5 10.25 22.5H4.75C3.7835 22.5 3 21.7165 3 20.75V3.25Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.9936 12.75L16.2945 16.2342C16.5793 16.5349 16.5665 17.0096 16.2658 17.2945C15.9651 17.5793 15.4904 17.5665 15.2055 17.2658L10.7055 12.5158C10.4315 12.2265 10.4315 11.7735 10.7055 11.4842L15.2055 6.73419C15.4904 6.43349 15.9651 6.42066 16.2658 6.70554C16.5665 6.99041 16.5793 7.46511 16.2945 7.76581L12.9937 11.25H21.25C21.6642 11.25 22 11.5858 22 12C22 12.4142 21.6642 12.75 21.25 12.75H12.9936Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgSignIn;
